import AppText from "../../../_shared/components/AppText";
import { Link, useParams } from "react-router-dom";

import BackIcon from "../../../_shared/components/BackIcon";
import useRestList from "../../../_shared/hooks/useRestList";
import { useEffect, useState } from "react";
import { Modal } from "antd";
import SlideImages from "../../../_shared/components/SlideImages";
import { Carousel } from "antd";
import HtmlText from "../../../_shared/components/HtmlText";
import CloseIcon from "../../../_shared/components/CloseIcon";
import FinishesPage from "../../../_shared/components/FinishesPage";
import HeaderActions from "../../../_shared/components/HeaderActions";

function Product(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);
  const { categoryId, id } = useParams();

  const [allProducts] = useRestList("/products", null, {
    id: id,
  });

  const [product, setProduct] = useState();

  const [subProducts, setSubProducts] = useState();

  const [selectedCF, setSelectedCF] = useState();
  const [selectedCFIndex, setSelectedCFIndex] = useState(0);

  const [openSelectedFinishesProduct, setOpenSelectedFinishesProduct] =
    useState(false);
  const [openSelectedFinishesVersion, setOpenSelectedFinishesVersion] =
    useState(false);

  const [selectedIndexCF, setSelectedIndexCF] = useState();
  const [selectedIndexCFVersion, setSelectedIndexCFVersion] = useState();
  const [selectedIndexProduct, setSelectedIndexProduct] = useState(0);

  useEffect(() => {
    console.log("openSelectedFinishesVersion", openSelectedFinishesVersion);
  }, [openSelectedFinishesVersion]);

  useEffect(() => {
    setProduct(allProducts.find((x) => x?.id === id.toString()));
    setSubProducts(
      allProducts?.filter((x) => x?.parentProduct === id.toString())
    );
  }, [allProducts, categoryId, id]);

  const headerLabels = (index, field) => {
    return (
      <div
        onClick={() =>
          selectedIndexCF === index
            ? setSelectedIndexCF(null)
            : field?.images?.[0]
            ? setSelectedCF(field)
            : setSelectedIndexCF(index)
        }
        style={{ cursor: "pointer", marginTop: 10 }}
      >
        <div className="row">
          <AppText small bold>
            >
          </AppText>
          <AppText small underline bold>
            {field?.name.it}
          </AppText>
          <AppText small underline>
            {" "}
            / {field?.name.en}
          </AppText>
        </div>

        {selectedIndexCF === index && (
          <div style={{ marginLeft: 15 }}>
            <HtmlText text={field?.text}></HtmlText>
          </div>
        )}
      </div>
    );
  };
  const headerLabelsVersion = (index, field) => {
    return (
      <div
        onClick={() =>
          selectedIndexCFVersion === index
            ? setSelectedIndexCFVersion(null)
            : setSelectedIndexCFVersion(index)
        }
        style={{ cursor: "pointer", marginTop: 10 }}
      >
        <div className="row">
          <AppText small bold>
            >
          </AppText>
          <AppText underline small bold>
            {field?.name.it}
          </AppText>
          <AppText underline small>
            {" "}
            / {field?.name.en}
          </AppText>
        </div>

        {selectedIndexCFVersion === index && (
          <div style={{ marginLeft: 15 }}>
            <HtmlText text={field?.text}></HtmlText>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="rootProducts">
      <Modal
        open={true}
        closable={false}
        footer={[]}
        centered
        className="modal"
        bodyStyle={{ height: "85vh", overflowY: "auto" }}
      >
        {/* opened selected custom field (es. "giroletto) */}
        {selectedCF ? (
          <div>
            <div
              className="row"
              style={{ justifyContent: "space-between", display: "flex" }}
            >
              <div className="row">
                <AppText bold>{selectedCF?.name?.it}</AppText>
                <AppText> / {selectedCF?.name?.en}</AppText>
              </div>
              <CloseIcon onClick={() => setSelectedCF()}></CloseIcon>
            </div>
            <SlideImages
              image={selectedCF?.images[selectedCFIndex]}
              onPlus={() =>
                selectedCFIndex < selectedCF?.images.length - 1
                  ? setSelectedCFIndex(selectedCFIndex + 1)
                  : setSelectedCFIndex(0)
              }
              onMinus={() =>
                selectedCFIndex !== 0
                  ? setSelectedCFIndex(selectedCFIndex - 1)
                  : setSelectedCFIndex(selectedCF?.images.length - 1)
              }
              showArrows={selectedCF?.images?.length > 1}
              style={{
                maxWidth: "90vh",
              }}
            ></SlideImages>
          </div>
        ) : openSelectedFinishesProduct ? (
          <FinishesPage
            finishes={product?.finishes}
            fabrics={product?.fabrics}
            onClose={() => setOpenSelectedFinishesProduct(false)}
          ></FinishesPage>
        ) : (
          <div>
            {/* product details */}
            {/* category names right up */}
            <div className="row" style={{ justifyContent: "space-between" }}>
              <div>
                <div className="row">
                  <AppText bold big>
                    {product?.name?.it}
                  </AppText>
                  {product?.name?.en && (
                    <AppText big> / {product?.name?.en}</AppText>
                  )}
                </div>
              </div>
              <div className="row">
                <HeaderActions></HeaderActions>
                <CloseIcon></CloseIcon>
              </div>
            </div>
            {/* product custom fields */}
            <div style={{ marginTop: 10 }}>
              {product?.customField?.map((cf, index) => {
                return headerLabels(index, cf);
              })}
              <div
                className="row"
                style={{ cursor: "pointer", marginTop: 10 }}
                onClick={() => setOpenSelectedFinishesProduct(true)}
              >
                <AppText small bold>
                  >
                </AppText>
                <AppText small underline bold>
                  finiture
                </AppText>
                <AppText small underline>
                  {" "}
                  / finishes
                </AppText>
              </div>
            </div>
            {/* version details */}
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-beetween",
                marginTop: 30,
              }}
            >
              <div
                style={{
                  width: "65%",
                }}
              >
                {/* images */}
                <SlideImages
                  image={subProducts?.[selectedIndexProduct]?.details}
                  onPlus={() =>
                    selectedIndexProduct === subProducts?.length - 1
                      ? setSelectedIndexProduct(0)
                      : setSelectedIndexProduct(selectedIndexProduct + 1)
                  }
                  onMinus={() =>
                    selectedIndexProduct === 0
                      ? setSelectedIndexProduct(subProducts?.length - 1)
                      : setSelectedIndexProduct(selectedIndexProduct - 1)
                  }
                  showArrows={subProducts?.length > 1}
                  style={{
                    maxWidth: "55vw",
                    // maxHeight: "100vh",
                  }}
                  noCenter
                ></SlideImages>
              </div>
              {/* version custom fields */}
              <div
                style={{
                  width: "30%",
                  marginLeft: "3%",
                }}
              >
                <div className="row">
                  <AppText small bold>
                    Dettaglio immagine
                  </AppText>
                  <AppText small>/ Image details</AppText>
                </div>

                {subProducts?.[selectedIndexProduct]?.customField?.map(
                  (cf, index) => {
                    return headerLabelsVersion(index, cf);
                  }
                )}
                <div
                  className="row"
                  style={{ cursor: "pointer", marginTop: 10 }}
                  onClick={() =>
                    setOpenSelectedFinishesVersion(!openSelectedFinishesVersion)
                  }
                >
                  <AppText small bold>
                    >
                  </AppText>
                  <AppText small underline bold>
                    finiture
                  </AppText>
                  <AppText small underline>
                    {" "}
                    / finishes
                  </AppText>
                </div>
                <div style={styles.finMargin}>
                  {openSelectedFinishesVersion && (
                    <div>
                      {subProducts?.[selectedIndexProduct]?.finishes?.map(
                        (fin) => (
                          <div className="row">
                            <AppText small bold>
                              {fin?.name?.it}
                            </AppText>
                            <AppText small>/ {fin?.name?.en}</AppText>
                          </div>
                        )
                      )}
                      {subProducts?.[selectedIndexProduct]?.fabrics?.map(
                        (fabric) => (
                          <div className="row">
                            <AppText small bold>
                              {fabric?.name?.it}{" "}
                              {fabric?.parentFabric?.name?.it}
                            </AppText>
                            {fabric?.name?.en && (
                              <AppText small>
                                / {fabric?.name?.en}{" "}
                                {fabric?.parentFabric?.name?.en}
                              </AppText>
                            )}
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

const styles = {
  finMargin: {
    marginLeft: 15,
    marginTop: 4,
  },
};

export default Product;
